import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from "@heroui/react";
import { AlertTriangle } from "lucide-react";

export default function WarningModal({ isOpen, onOpenChange, title, message, onConfirm }) {
  return (
    <Modal isOpen={isOpen} placement="center" onOpenChange={onOpenChange}>
      <ModalContent>
        {(onClose) => (
          <>
            {/* 📌 Header avec Icône d'Alerte */}
            <ModalHeader className="flex items-center gap-2 text-red-600">
              <AlertTriangle size={24} className="text-red-600" />
              {title || "Attention"}
            </ModalHeader>

            {/* 📌 Message d'avertissement */}
            <ModalBody>
              <p className="text-gray-700 dark:text-gray-300">{message || "Êtes-vous sûr de vouloir effectuer cette action ? Cette action est irréversible."}</p>
            </ModalBody>

            {/* 📌 Boutons */}
            <ModalFooter>
              <Button color="danger" variant="light" onPress={onClose}>
                Annuler
              </Button>
              <Button color="primary" onPress={() => { onConfirm(); onClose(); }}>
                Confirmer
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
